import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0003 extends BaseRule {
    name = 'Physio 0003: 15% reduction for non-owned equipment';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0003') return;

        if (autoApply) {
            // Apply 15% reduction to the line
            line.adjustedUnits = line.adjustedUnits * 0.85;
            if (line.adjustedRand) {
                line.adjustedRand = +(line.adjustedRand * 0.85).toFixed(2);
            }
            line.trace.push('Physio 0003: 15% reduction for non-owned equipment');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0003',
                message: '15% of the relevant rate to be deducted where equipment used is not owned by the practitioner',
                kind: 'overwrite',
                unitsDelta: line.adjustedUnits * 0.85
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0003') {
                line.adjustedUnits = line.adjustedUnits * 0.85;
                if (line.adjustedRand) {
                    line.adjustedRand = +(line.adjustedRand * 0.85).toFixed(2);
                }
                line.trace.push('Physio 0003: 15% reduction for non-owned equipment');
            }
        });
        return lines;
    }
} 